{
	"users": {
		"usernameMin": "At least 3 characters",
		"usernameFormat": "No '@' or spaces",
		"usernameNumeric": "Cannot be only digits: those usernames belong to card numbers",
		"emailInvalid": "Enter a valid email",
		"phoneMin": "At least 3 characters",
		"passwordMin": "At least 8 characters",
		"nameRequired": "Enter a name",
		"rolesRequired": "Pick at least one role",
		"confirmPasswordRequired": "Enter your own password to confirm",
		"newPasswordRequired": "Type the new password, or choose Generate"
	},
	"countries": {
		"codeExactThree": "Exactly three letters",
		"callingCodeFormat": "Like +60",
		"urlInvalid": "Enter a valid URL",
		"nameRequired": "Enter a name"
	},
	"responsibleOrganizations": {
		"nameRequired": "Enter a name"
	},
	"subAgencies": {
		"nameRequired": "Enter a name"
	},
	"affiliatedOrganizations": {
		"nameRequired": "Enter a name"
	},
	"functions": {
		"nameRequired": "Enter a name",
		"codeRequired": "Enter a code",
		"codeFormat": "Letters, numbers, - and _ only",
		"cardColorFormat": "Like #D4AF37",
		"sortOrderInvalid": "Enter a whole number, 0 or more"
	},
	"competition": {
		"nameRequired": "Enter a name",
		"nameTooLong": "{{max}} characters at most",
		"codeRequired": "Enter a code",
		"codeFormat": "Letters, numbers, - and _ only, starting with a letter or a number (20 at most)",
		"sortOrderInvalid": "Enter a whole number from 0 to {{max}}",
		"translationTooLong": "{{max}} characters at most",
		"iconUrlInvalid": "Enter a web address starting with http:// or https://",
		"disciplineRequired": "Pick a discipline",
		"genderRequired": "Pick who may enter",
		"competitorTypeRequired": "Pick individual or team",
		"resultFamilyRequired": "Pick how results are recorded",
		"resultTypeRequired": "Pick what the result measures",
		"teamSizeInvalid": "Enter a whole number from 1 to {{max}}",
		"teamSizeTeamOnly": "Team sizes apply only to team events",
		"teamSizeMinOverMax": "The largest team cannot be smaller than the smallest",
		"medalCountInvalid": "Enter a whole number from 0 to {{max}}",
		"maxEntriesInvalid": "Enter a whole number from 1 to {{max}}",
		"ceremonyInvalid": "Enter a date and time",
		"sportClassesTooMany": "{{max}} classes at most",
		"sportClassesDuplicate": "List each class once",
		"cityTooLong": "{{max}} characters at most",
		"parentInvalid": "Pick a venue from the list",
		"maxShortlistInvalid": "Enter a whole number from 1 to {{max}}",
		"maxShortlistBelowEntries": "The shortlist quota cannot be below the entry quota",
		"qualifyingMarkInvalid": "Enter the mark the way the sport writes it (a time like 1:58.50, a distance like 7.85, a number)",
		"qualifyingMarkNoMeasure": "An event whose result measures nothing has no qualifying standard",
		"qualifyingNoteTooLong": "{{max}} characters at most"
	},
	"auth": {
		"identifierRequired": "Enter your username or email",
		"passwordRequired": "Enter your password",
		"codeRequired": "Enter the 6-digit code",
		"currentPasswordRequired": "Enter your current password",
		"newPasswordMin": "At least 8 characters",
		"newPasswordSame": "New password must be different from the current one",
		"confirmPasswordMismatch": "The passwords do not match"
	},
	"userGroups": {
		"nameRequired": "Enter a name",
		"nameMax": "At most {{max}} characters",
		"descriptionMax": "At most {{max}} characters",
		"roleRequired": "Pick a role",
		"scopeEmpty": "Pick at least one of organization, main function, sub-agency or sub-function",
		"scopesMax": "At most {{max}} scope rows per group",
		"scopeDuplicate": "This scope row is listed twice",
		"permissionDuplicate": "A permission is listed twice",
		"sportsMax": "At most {{max}} sports per group",
		"sportDuplicate": "A sport is listed twice"
	},
	"organizationTypes": {
		"codeRequired": "Enter a code",
		"codeFormat": "Letters, numbers, - and _ only",
		"nameRequired": "Enter a name",
		"subAgencyLabelRequired": "Enter what the sub-agency picker is called",
		"sortOrderInvalid": "Enter a whole number, 0 or more"
	},
	"accessCodes": {
		"codeRequired": "Enter a code",
		"codeFormat": "Letters, numbers, - and _ only",
		"nameRequired": "Enter a name",
		"sortOrderInvalid": "Enter a whole number, 0 or more"
	},
	"handoverLocations": {
		"nameRequired": "Enter a name",
		"sortOrderInvalid": "Enter a whole number, 0 or more"
	},
	"accreditation": {
		"required": "Required",
		"textTooLong": "Too long",
		"accreditationNameMax": "At most {{max}} characters",
		"tvShortNameMax": "At most {{max}} characters",
		"emailInvalid": "Enter a valid email",
		"dateInvalid": "Enter a valid date",
		"dateTimeInvalid": "Enter a valid date and time",
		"countryInvalid": "Pick a country",
		"numberInvalid": "Enter a number",
		"remarksRequired": "Enter a remark for the organisation",
		"personOrPeopleId": "Enter the person's details, or pick an existing person",
		"closesAfterOpens": "Must be after the opening time",
		"nothingToChange": "Nothing to change",
		"idsOrFilter": "Select records, or use the whole filtered list"
	}
}
